/**
 * @author Milton Filho
 */

/**
 * The status the API answers when Clinicient already holds the slot.
 *
 * It used to be `500`, which reads as "try again" — and the queue obliged, on
 *   every reconnection. Named here because the meaning is what matters at both
 *   call sites: permanent refusal, not a transient failure.
 */
export const BOOKING_CONFLICT_STATUS = 409;

/**
 * How long to wait for the schedule refetch that decides whether a conflicted
 * booking's optimistic card can be removed.
 *
 * On expiry the card stays. That is the safe direction: the `409` proved the
 *   slot is taken in Clinicient, and if we cannot confirm our own schedule
 *   knows it, leaving the slot looking occupied beats leaving it looking free.
 */
export const CONFLICT_REFETCH_TIMEOUT_MS = 15_000;
